export default __webpack_public_path__ + "static/newsletter-logo-6601c21ca4f2844311582f6e2a1ada68.png";